import { Routes } from '@angular/router';
import { MtmAuthRedirectComponent } from '@mtm/auth-ui-angular';
import { authGuard, loginGuard, tenantSelectGuard } from './core/guards/auth.guard';
import { LoginPageComponent } from './features/auth/login/login-page.component';
import { TenantSelectPageComponent } from './features/auth/tenant-select/tenant-select-page.component';
import { AppShellComponent } from './layout/shell/app-shell.component';
import { environment } from '../environments/environment';
import { unsavedChangesGuard } from './core/unsaved-changes.guard';

export const appRoutes: Routes = [
  { path: 'login', component: LoginPageComponent, canActivate: [loginGuard] },
  {
    path: 'tenant-select',
    component: TenantSelectPageComponent,
    canActivate: [tenantSelectGuard],
  },
  {
    path: environment.authProcessUrl.replace(/^\//, ''),
    component: MtmAuthRedirectComponent,
  },
  // The SSO provider redirects back to `appSsoCallback`, not to `authProcessUrl`.
  // Without this route it fell through to `**` and bounced to /login, taking the
  // callback's one-time token with it.
  {
    path: environment.ssoCallbackUrl.replace(/^\//, ''),
    component: MtmAuthRedirectComponent,
  },
  {
    // Same shell as /login, and no resolver: `mtm-auth` reads `?password=` from
    // `window.location` itself and renders its own invalid-link error. There was
    // no route here at all, so the emailed reset link landed on `**` -> /login.
    path: environment.resetPasswordUrl.replace(/^\//, ''),
    component: LoginPageComponent,
  },
  { path: '', pathMatch: 'full', redirectTo: 'tenants' },
  {
    path: '',
    component: AppShellComponent,
    canMatch: [authGuard],
    children: [
      {
        path: 'tenants',
        loadComponent: () =>
          import('./features/tenants/tenants-page.component').then((c) => c.TenantsPageComponent),
      },
      {
        path: 'accounts',
        loadComponent: () =>
          import('./features/accounts/accounts-members.component').then(
            (c) => c.AccountsMembersComponent,
          ),
      },
      {
        path: 'accounts/:accountUuid/hive',
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import('./features/permissions/account-hive-page.component').then(
            (c) => c.AccountHivePageComponent,
          ),
      },
      {
        path: 'groups',
        loadComponent: () =>
          import('./features/groups/accounts-groups.component').then(
            (c) => c.AccountsGroupsComponent,
          ),
      },
      {
        path: 'groups/:groupId',
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import('./features/groups/details/group-details-page.component').then(
            (c) => c.GroupDetailsPageComponent,
          ),
      },
      {
        path: 'help',
        loadComponent: () =>
          import('./features/help/help-page.component').then((c) => c.HelpPageComponent),
      },
      {
        path: 'console',
        loadChildren: () => import('./features/console').then((m) => m.consoleRoutes),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
